import script from "./TwoButtonPopup.vue?vue&type=script&setup=true&lang=js"
export * from "./TwoButtonPopup.vue?vue&type=script&setup=true&lang=js"

import "./TwoButtonPopup.vue?vue&type=style&index=0&id=54a21b9a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-54a21b9a"]])

export default __exports__